import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m17.317 10.818-5.625 5.624a.625.625 0 1 1-.884-.884L15.366 11H3.125a.625.625 0 1 1 0-1.25h12.241l-4.558-4.557a.625.625 0 0 1 .884-.885l5.625 5.625a.626.626 0 0 1 0 .885"
    }, null, -1)
  ])))
}
export default { render: render }